const translations: Record<string, string> = {
  "ak_ueex_mwh_deals": "{{mwh}} MWh | {{n}} deals",
  "ak_ueex_mwh": "{{mwh}} MWh",
  "ak_ueex_uah": "{{n}} UAH",
  "ak_ueex_mwh_2": "{{n}} MWh",
  "ak_ueex_uah_2": "UAH",
  "ak_ueex_uah_mwh": "UAH/MWh",
  "ak_ueex_mwh_3": "MWh",
  "ak_ueex_lots": "lots",
  "ak_ueex_deals": "deals",
  "ak_ueex_block": "Block",
  "ak_ueex_base_vs_block": "BASE vs Block",
  "ak_ueex_offered_mwh": "Offered MWh",
  "ak_ueex_uah_excl_vat": "UAH excl. VAT",
  "ak_ueex_mwh_deals_2": "{{mwh}} MWh · {{n}} deals",
};

export default translations;
